import { API_URL, Status } from '../constants';
import { fetch } from '../fetchWrapper/fetch';
import { toApiError } from 'src/helpers/apiError';

/**
 * Pass the root publish event to commit every pending plan under it, and the channel events whose
 * plans were reviewed. The API refuses with `plan_changed` if a plan arrived that wasn't reviewed.
 */
export const commitPublishPlan = async (eventId: string, reviewedEventIds: string[]): Promise<void> => {
  const res = await fetch(`${API_URL}/publish/commit`, {
    method: 'POST',
    body: JSON.stringify({ event_id: eventId, reviewed_event_ids: reviewedEventIds }),
    headers: {
      'Content-Type': 'application/json',
    },
  });

  if (!res.ok && res.status !== Status.ACCEPTED) {
    // A 409/422 carries the refusal (plan changed, expired, already committed, blockers) as `message`.
    throw await toApiError(res, 'The changes could not be accepted.');
  }
};
